import { render, staticRenderFns } from "./CardUserManagement.vue?vue&type=template&id=1b420ede&scoped=true"
import script from "./CardUserManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardUserManagement.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/components/cardUsers/styles/card-user-management-style.css?vue&type=style&index=0&id=1b420ede&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b420ede",
  null
  
)

/* custom blocks */
import block0 from "@/components/cardUsers/locales/i18n-card-user-management.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2FcardUsers%2FCardUserManagement.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports